export default {
    "en": {
        "timeline": {
            "reminder": "Reminder:"
        },
        "waze": {
            "system": {
                "failed_to_encode_address_with_google": "Failed to encode provided address with Google Geocode"
            }
        },
        "email": {
            "log": {
                "default_message": "{user} triggered notification. Notification sent for",
                "default_type": "Shop Drawings",
                "rfi_answered": "{user} answered RFI. Notification sent for",
                "rfi_raised": "{user} raised RFI. Notification sent for",
                "service_appointment_assigned": "Service Appointment was assigned to {user}. Notification sent for",
                "service_appointment_assigned_reminder": "Service Appointment was not Accepted or Declined for more than 2 days. Notification sent for",
                "service_appointment_assigned_soon_visit_date": "Service Appointment visit date in next 24 hours. Notification sent for",
                "service_appointment_cancelled": "{user} cancelled Service Appointment. Notification sent for",
                "service_appointment_report_declined": "{user} declined Service Appointment Report. Notification sent for",
                "service_appointment_report_declined_reminder": "Service Appointment Report was Declined for more than 2 days. Notification sent for",
                "service_appointment_report_submitted": "{user} submitted Service Appointment Report. Notification sent for",
                "service_appointment_report_submitted_reminder": "Service Appointment Report was not Approved or Declined for more than 2 days. Notification sent for",
                "service_appointment_updated": "{user} updated Service Appointment. Notification sent for",
                "shop_drawing_additional_request_cancelled": "{user} cancelled {type}. Notification sent for",
                "shop_drawing_additional_request_requested": "{user} requested for {type}. Notification sent for",
                "shop_drawing_additional_request_submitted": "{user} submitted {type}. Notification sent for",
                "shop_drawing_assigned": "{user} assigned {request_type} for {drafter}. Notification sent for",
                "shop_drawing_canceled": "{user} canceled {request_type} Request. Notification sent for",
                "shop_drawing_cross_checking_drafter_assigned": "Shop Drawings Cross-Checking Drafter has been assigned. Notification sent for ",
                "shop_drawing_draft": "{request_type} request has not been submitted for more than 2 days. Notification sent for ",
                "shop_drawing_draft_approved": "{request_type} has been completed for {project_number} - {project_name}",
                "shop_drawing_draft_rejected": "{user} rejected {request_type} notification sent for",
                "shop_drawing_draft_uploaded": "{request_type} uploaded by {user} notification sent for",
                "shop_drawing_hold": "{request_type} Request hold notification sent for {recipients}",
                "shop_drawing_request_new": "{user} requested for {request_type}. Notification sent for",
                "shop_drawing_request_revision": "{user} requested for {request_type} revision request. Notification sent for",
                "shop_drawing_signed_submitted": "Signed {request_type} were submitted by {user}. Notification sent for",
                "shop_drawing_task_info_changed": "{user} changed {request_type} Task Information. Notification sent for",
                "shop_drawing_unhold": "{request_type} Request unhold notification sent for {recipients}"
            },
            "subject": {
                "shop_drawings": {
                    "additional_request": {
                        "installation_details": "Shop Drawings Installation Details",
                        "shop_drawing_for_production": "Shop Drawings for Production"
                    }
                }
            }
        },
        "request_duration_management": {
            "additional_default_time": "Additional Default Time",
            "edit_modal_closed": "Edit Modal Closed",
            "expected_duration_column": "Expected Duration",
            "fill_mandatory_fields": "Some of the \"Request Duration\" field entries are missing.",
            "min_threshold_column": "Min. Threshold",
            "per_position_column": "Per Unique Position",
            "request_duration": "Request Duration",
            "request_type_column": "Request Type",
            "save_request_duration": "Save"
        },
        "priority_settings": {
            "actions": "Actions",
            "history": "Priority Settings History",
            "name": "Name",
            "open_changelog": "View Changes History",
            "type": "Type"
        },
        "cross_checklist_report": {
            "actual_duration_hours": "Actual Duration Hours",
            "attachments": "Attachments",
            "complete": "Complete",
            "completed_by": "Completed By",
            "cross_check": "Cross-Check",
            "cross_check_assignee": "Cross-Check Assignee",
            "fill_mandatory_fields": "Some of the \"Cross-Check List Report\" field entries are missing.",
            "title": "Cross-Check List",
            "updated_by": "Updated By",
            "updated_on": "Updated On",
            "view_list": "View List"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "rfi": {
            "block": {
                "buttons": {
                    "new_rfi": "New RFI"
                },
                "title": "Request for Information"
            },
            "input": {
                "already_answered": "There’s no RFI to be answered",
                "attach_file": {
                    "invalid_data": "System does not support this document format. Available formats - {extensions}",
                    "title": "Attach File",
                    "upload_failed": "File upload failed. Please try again"
                },
                "buttons": {
                    "answer": "Answer",
                    "rfi": "RFI"
                },
                "textarea_placeholder": "Type Your Message",
                "upload_in_progress": "Please wait until the file upload is finished"
            },
            "search": {
                "placeholder": "Search"
            },
            "select": {
                "assignee_placeholder": "Select Assignee of RFI"
            },
            "system": {
                "error": {
                    "already_answered": "There’s no RFI to be answered",
                    "fill_mandatory_fields": "Please make sure that message and assignee fields are applied",
                    "not_allowed_recipient": "User you selected is unavailable. Please contact IT to confirm the assignees",
                    "not_participant": "You are not RFI owner or assignee"
                },
                "failed_to_load_rfi": "Message can not be loaded. Please try to reload",
                "successfully_sent_answer": "RFI answered successfully",
                "successfully_sent_rfi": "RFI sent for {users}"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} must have between {min} and {max} items.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} must be between {min} and {max}.",
                "string": "The {attribute} must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "erp_extension": "The {attribute} has not allowed file extension. File must be one of: {extensions}.",
            "erp_file_object": "The {attribute} is not a valid file object.",
            "erp_reference_object": "The {attribute} is not a valid reference object.",
            "erp_weekday": "The {attribute} is not a weekday.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "array": "The {attribute} must have more than {value} items.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "numeric": "The {attribute} must be greater than {value}.",
                "string": "The {attribute} must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} must have {value} items or more.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "string": "The {attribute} must be greater than or equal {value} characters."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "array": "The {attribute} must have less than {value} items.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "numeric": "The {attribute} must be less than {value}.",
                "string": "The {attribute} must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} must not have more than {value} items.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "numeric": "The {attribute} must be less than or equal {value}.",
                "string": "The {attribute} must be less than or equal {value} characters."
            },
            "max": {
                "array": "The {attribute} may not have more than {max} items.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "numeric": "The {attribute} may not be greater than {max}.",
                "string": "The {attribute} may not be greater than {max} characters."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} must have at least {min} items.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "numeric": "The {attribute} must be at least {min}.",
                "string": "The {attribute} must be at least {min} characters."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "array": "The {attribute} must contain {size} items.",
                "file": "The {attribute} must be {size} kilobytes.",
                "numeric": "The {attribute} must be {size}.",
                "string": "The {attribute} must be {size} characters."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID."
        },
        "factory_test": {
            "approved_successfully": "Factory Test was successfully approved.",
            "custom_testing": "Custom Testing",
            "dashboard": {
                "list": {
                    "factory_test_status": "Status",
                    "factory_test_technician": "Assigned To",
                    "factory_test_type": "Type",
                    "only_my": "My Reports",
                    "report_id": "Number",
                    "status": "Factory Test Status",
                    "title": "Factory Tests List"
                }
            },
            "date": "Date",
            "description": "Testing Task",
            "edit_modal": {
                "approve_button": "Approve",
                "approve_reason": "Please provide a reason for approval",
                "approve_report": "Approve Report",
                "cancel_factory_test": "Cancel",
                "cancel_report": "Cancel Report",
                "fill_mandatory_fields": "Some of the \"Factory Test\" field entries are missing",
                "no_factory_test": "Factory Test types failed to load.",
                "reject_button": "Reject",
                "reject_reason": "Please provide a reason for rejection",
                "reject_report": "Reject Report",
                "request_approved": "Request was approved by {name} on {at}.",
                "request_rejected": "Request was rejected by {name} on {at}.",
                "select_factory_test": "Select Factory Test Type"
            },
            "history": "Testing Subjects History",
            "linked_task": "Linked Task",
            "open_changelog": "View Changes History",
            "rejected_successfully": "Factory Test was successfully rejected.",
            "report_modal": {
                "assignee": "Assignee",
                "cancel_report": "Cancel Report",
                "fill_mandatory_fields": "Some of the \"Factory Test Report\" field entries are missing.",
                "linked_task": "Link to Zoho Project Task",
                "task_no": "Zoho Project Task"
            },
            "results_and_recommendations": "Results & Recommendations",
            "system": {
                "factory-test": {
                    "canceled": "Factory Test was successfully canceled.",
                    "completed": "Factory Test was successfully completed.",
                    "failed": "Failed to save Factory Test!",
                    "saved_successfully": "Factory Test was saved successfully",
                    "wrong_stage": "Factory Test can not be changed at this stage!"
                },
                "list": {
                    "get_failed": "Failed to retrieve Factory Test list. Please, try again or contact IT if problem persists."
                }
            },
            "task_no": "Task Name",
            "testing_subjects": "Testing Subject",
            "testing_summary": "Results and Recommendations",
            "testings": "Testing Objectives",
            "wrong_version": "This action is not supported by current Factory Test version."
        },
        "service_appointments": {
            "calendar": {
                "title": "Service Calendar"
            },
            "dashboard": {
                "filters": {
                    "assignees": "Assignee",
                    "filter": "Filter",
                    "report_statuses": "Report Status",
                    "service_types": "Service/Report Type",
                    "statuses": "Service Status",
                    "title": "Filters"
                },
                "list": {
                    "actions": "Actions",
                    "add_new": "Add New",
                    "applied_filters": "Applied Filters",
                    "contact_person": "Contact Person",
                    "export_excel": "Export Excel",
                    "filters": "Filters",
                    "location": "Location",
                    "no_records": "No Records",
                    "of": "of",
                    "only_my": "My Appointments",
                    "open_report": "Open Report",
                    "open_service": "Open Service",
                    "project_name": "Project Name",
                    "report_status": "Report Status",
                    "search": "Search",
                    "service_date": "Service Date",
                    "service_id": "Service ID",
                    "service_technician": "Service Technician",
                    "service_type": "Service Type",
                    "show_num": "Show",
                    "status": "Service Status",
                    "title": "Service Appointments List",
                    "view_report": "View Report",
                    "view_service": "View Service",
                    "zoho_desk_ticket_no": "Zoho Desk ticket #"
                }
            },
            "delete": {
                "accept_text": "Confirm",
                "description": "After removing the Service, the data will be lost. Please, confirm you want to remove the Service Appointment",
                "fail_text": "Service Appointment Removal Failed",
                "success_text": "Service Appointment Removed",
                "title": "Warning!"
            },
            "edit_modal": {
                "add_contact": "Add Contact",
                "address": "Address",
                "assignee": "Assigned To",
                "attachments": "Attachments",
                "buttons": {
                    "remove_attachment_title": "Remove",
                    "upload_attachments": "Add Attachments"
                },
                "cancel": "Cancel",
                "cancel_request": "Cancel Service",
                "cancel_service": "Cancel Service",
                "canceled_reason": "Please provide a reason for cancellation",
                "confirm": "Confirm",
                "contact_person": "Contact Person",
                "created_by": "Created By",
                "description": "Description",
                "email": "Email",
                "expected_duration": "Expected Duration",
                "fill_mandatory_fields": "Some of the \"Service Appointment\" field entries are missing",
                "fill_mandatory_reason": "Mandatory reason field is missing",
                "find_time": "Find Time",
                "finish_service": "Finish Service",
                "hours": "hours",
                "hover": {
                    "disabled_project_order_change": "Attention! Attachments are uploaded to specified Project/Order, please remove attachments to change Project/Order!"
                },
                "initial_status": "Draft",
                "no_assignees": "Assignees failed to load.",
                "no_expected_durations": "Service expected durations failed to load.",
                "no_order": "No orders were found containing given search term.",
                "no_project": "No projects were found containing given search term.",
                "no_responsible_party": "Responsible Party types failed to load",
                "no_service_types": "Service types failed to load.",
                "not_found": "Appointment not found.",
                "order": "Order",
                "phone": "Phone",
                "project": "Project",
                "reason": "Reason",
                "report_details": "Report Details",
                "request_canceled": "Request was cancelled by {name} {at}.",
                "responsible_party": "Responsible Party",
                "responsible_party_placeholder": "Select Responsible Party",
                "select_assignee": "Select Assignee",
                "select_expected_duration": "Select Expected Duration",
                "select_order": "Select Order",
                "select_project": "Select Project",
                "select_service_type": "Select Service Type",
                "service_date": "Service Date",
                "service_type": "Service Type",
                "service_visit_details": "Service Visit Details",
                "shop_drawing_url": "Link to Shop Drawing",
                "showing_top_results": "Showing top {top} results.",
                "start_report": "Start Report",
                "start_service": "Start Service",
                "submit": "Submit",
                "time_range": "Date & Time",
                "time_range_from": "From",
                "time_range_to": "To",
                "travel_duration": "Travel Duration",
                "update": "Update",
                "visit_duration": "Service visit duration",
                "zoho_desk_ticket_no": "ZOHO Desk Ticket"
            },
            "input": {
                "attach_file": {
                    "upload_failed": "File upload failed. Please try again"
                }
            },
            "nearby_appointments": {
                "list": {
                    "assignee": "Service Technician",
                    "date": "Date",
                    "distance_and_time": "Distance & Time",
                    "type": "Type"
                },
                "title": "Nearby Appointments",
                "wrong_address": "Nearby appointments are not available. Please review address."
            },
            "notification": {
                "canceled_at": "Cancelled At",
                "canceled_by": "Cancelled By",
                "canceled_reason": "Cancelled Reason",
                "created_at": "Created At",
                "time_range_end": "Time Range End",
                "time_range_start": "Time Range Start",
                "updated_at": "Updated At",
                "updated_by": "Updated By"
            },
            "report_modal": {
                "acm_summary": "ACM Summary",
                "acm_summary_explanation": "Give a detail account of your experience at job site & summary of what needs to be inspected on next ACM.",
                "add_damage": "Add Damage",
                "add_damage_from_qr": "Add from QR",
                "add_referral": "Add Referral",
                "additional_images": "Images",
                "additional_notes": {
                    "add_notes": "Add Notes",
                    "attachments": "Additional Notes Attachments",
                    "confirm": {
                        "text": "Are you sure you want to remove {note}?",
                        "title": "Are you sure?"
                    },
                    "description": "Note",
                    "index": "Additional Notes",
                    "name": "#{no} Additional Note",
                    "test": "Additional Note",
                    "test_images": "Images"
                },
                "address": "Address",
                "appointment_details": "Appointment Details",
                "approve": "Approve",
                "approve_and_update": "Approve & Update",
                "approved_by": "Approved by",
                "are_there_any_referrals": "Are there any upcoming projects referrals or contacts to report?",
                "assignee": "Assignee",
                "cancel": "Cancel",
                "cancel_report": "Cancel Report",
                "canceled_reason": "Please provide a reason for cancellation",
                "care_and_maintenance_attachments": "Care & Maintenance Attachments",
                "care_and_maintenance_images": "Care & Maintenance Images",
                "checkbox_attachments": "Attachments",
                "checklist": "Checklist",
                "contact_on_site": "Contact on Site",
                "contact_person": "Contact Person",
                "damages": {
                    "accessories": "Accessories",
                    "attachments": "Damages Attachments",
                    "canvas": {
                        "cancel": "Cancel",
                        "ok": "OK",
                        "reset": "Reset"
                    },
                    "color_int_ext": "Color int/ext",
                    "confirm": {
                        "text": "Are you sure you want to remove {damage}?",
                        "title": "Are you sure?"
                    },
                    "damage_index": "#{index} Damage",
                    "details": "Damage Details",
                    "details_explanation": "Supply detail description of damaged items.",
                    "dimensions": "Dimensions",
                    "doors_system": "Doors System",
                    "fillers": "Filler",
                    "handles": "Handle",
                    "horizontal_mullions": "Horizontal Mullions",
                    "images": "Damage Images",
                    "index": "Damages",
                    "inside_view": "Inside View",
                    "invalid_qr_code": "Scanned QR Code is invalid. Please try again.",
                    "name": "#{no} Damage",
                    "order_number": "Order Number",
                    "outside_view": "Outside View",
                    "position_location": "Position Location",
                    "position_no": "Position No",
                    "position_qr_code_id": "Position ID",
                    "project_name": "Project Name",
                    "sashes": "Sash",
                    "vertical_mullions": "Vertical Mullions",
                    "windows_system": "Windows System"
                },
                "date": "Date",
                "decline": "Decline",
                "decline_report": "Decline Report",
                "declined_reason": "Please provide a reason for decline",
                "delivery_attachments": "Delivery Attachments",
                "delivery_details": "Delivery Details",
                "delivery_details_explanation": "Please list any discrepancies that are observed on site based on check list above. Please explain any corrective action that need to be taken by the install of GC.",
                "delivery_handling_and_storage_attachments": "Delivery, Handling & Storage Attachments",
                "delivery_handling_and_storage_images": "Delivery, Handling & Storage Images",
                "delivery_handling_and_storage_notes": "Delivery, Handling & Storage Notes",
                "delivery_images": "Delivery Images",
                "delivery_inspection_attachments": "Delivery Inspection Attachments",
                "delivery_instruction_notes": "Delivery Instruction Notes",
                "delivery_instruction_notes_explanation": "Please note any observations on site based on check list above. Please explain any action that need to be taken by the installer or GC.",
                "delivery_summary": "Delivery Summary",
                "delivery_summary_explanation": "Give a detail account of your experience at job site.",
                "ez_mullion_attachments": "EZ Mullion Attachments",
                "ez_mullion_images": "EZ Mullion Images",
                "ez_mullion_notes": "EZ Mullion Notes",
                "files": {
                    "confirm": {
                        "text": "Are you sure you want to remove {file} file?",
                        "title": "Are you sure?"
                    },
                    "upload_file": "Drag & Drop or Select Files"
                },
                "fill_mandatory_fields": "Some of the \"Service Appointment Report\" field entries are missing.",
                "fill_mandatory_reason": "Mandatory reason field is missing",
                "floors_inspected": "Floors Inspected",
                "general_installation_methods_attachments": "General Installation Methods Attachments",
                "general_installation_methods_images": "General Installation Methods Images",
                "general_installation_methods_notes": "General Installation Methods Notes",
                "generated_on": "Generated On",
                "glazing_stops_notes": "Removing Glazing Stops Notes",
                "glazing_stops_notes_explanation": "Please note any observations on site based on check list above. Please explain any action that need to be taken by the installer or GC.",
                "handling_storage_notes": "Handling & Storage Notes",
                "handling_storage_notes_explanation": "Please note any observations on site based on check list above. Please explain any action that need to be taken by the installer or GC.",
                "inspection_attachments": "Inspection Attachments",
                "inspection_details": "Inspection Details",
                "inspection_details_explanation": "Please list any discrepancies that are observed on site based on check list above. Please explain any corrective action that need to be taken by the install of GC.",
                "inspection_images": "Inspection Images",
                "install_glass_units_attachments": "Removing & Replacing Insulated Glass Units Attachments",
                "install_glass_units_images": "Removing & Replacing Insulated Glass Units Images",
                "install_insulated_glass_units_notes": "Removing & Replacing Insulated Glass Units Notes",
                "installation_images": "Installation Images",
                "installation_notes": "Installation Notes",
                "installation_notes_explanation": "Please note any observations on site based on check list above. Please explain any action that need to be taken by the installer or GC.",
                "installation_training_summary": "Installation Training Summary",
                "installer_names_company": "Installer Names & Company",
                "intus_representative": "INTUS Representative",
                "items": {
                    "add_item": "Add Item",
                    "confirm": {
                        "text": "Are you sure you want to remove #{no} item?",
                        "title": "Are you sure?"
                    },
                    "description": "Please enter item(s) needed to be ordered by claims. Include in description: window position, size, color, hardware type, and any additional information.",
                    "header_description": "Description",
                    "header_number": "No",
                    "header_quantity": "Quantity",
                    "need_to_order": "Need to Order",
                    "title": "Claims: Items needed to be ordered"
                },
                "maintenance_notes": "Care & Maintenance Notes",
                "maintenance_notes_explanation": "Please note any observations on site based on check list above. Please explain any action that need to be taken by the installer or GC.",
                "mulling_images": "Mulling Images",
                "mulling_notes": "Mulling Notes",
                "mulling_notes_explanation": "Please note any observations on site based on check list above. Please explain any action that need to be taken by the installer or GC.",
                "mulling_windows_attachments": "Mulling Windows Attachments",
                "mulling_windows_images": "Mulling Windows Images",
                "mulling_windows_notes": "Mulling Windows Notes",
                "next_acm_date": "Next ACM Date",
                "next_acm_date_explanation": "Schedule & confirm next ACM visit with GC/Site Contact within next 30 days from current visit.",
                "observers_list": "List of Observers",
                "observers_list_explanation": "Please include First, Last Name, and Company.",
                "open_pdf_button": "Open PDF",
                "page": "Page",
                "page_of": "of",
                "performed_by": "Testing Being Performed By",
                "performed_by_explanation": "Specify company that is conducting test.",
                "pre_testing_inspection_attachments": "Pre Testing Inspection Attachments",
                "prepared_by": "Prepared by",
                "project": "Project",
                "reason": "Reason",
                "receptor_installation_attachments": "Receptor Installation Attachments",
                "receptor_installation_images": "Receptor Installation Images",
                "receptor_installation_notes": "Receptor Installation Notes",
                "referrals": {
                    "comments": "Comments",
                    "confirm": {
                        "text": "Are you sure you want to remove {referral}?",
                        "title": "Are you sure?"
                    },
                    "contact_email": "Contact Email",
                    "contact_name": "Contact Name",
                    "contact_phone": "Contact Phone Number",
                    "name": "#{no} Referral",
                    "title": "Referrals"
                },
                "referrals_no": "No",
                "referrals_yes": "Yes",
                "remove": "Remove",
                "report": "Report",
                "report_canceled": "Report was cancelled by {name} {at}.",
                "report_declined": "Report was declined by {name} {at}.",
                "save_as_draft": "Save as Draft",
                "service_attachments": "Service Attachments",
                "service_details": "Service Details",
                "service_details_explanation": "Please list all services completed & any observations on site based on check list above.",
                "service_images": "Service Images",
                "service_summary": "Service Summary",
                "service_summary_explanation": "Give a detail account of your experience at job site.",
                "service_visits": "Service Visits",
                "service_visits_explanation": "Please specify how many visits a technician has been on site for this specific service.",
                "submit": "Submit",
                "technician_name": "Technician Name",
                "testing_pressure": "Testing Pressure",
                "testing_pressure_explanation": "There shall be no water leakage at the above psf.",
                "testing_summary": "Field Testing Summary",
                "testing_summary_explanation": "Give a detail account of your experience at test, did window pass or fail.",
                "tests": {
                    "add_test": "Add Test",
                    "confirm": {
                        "text": "Are you sure you want to remove {test}?",
                        "title": "Are you sure?"
                    },
                    "description": "Testing Description",
                    "description_explanation": "Explain testing completed, details of position being tested. If test fail, please explain failure.",
                    "fail": "Fail",
                    "index": "Tests",
                    "name": "#{no} Test",
                    "pass": "Pass",
                    "test": "Test",
                    "test_attachments": "Testing Attachments",
                    "test_images": "Testing Images",
                    "test_index": "#{index} Test"
                },
                "text_fields": {
                    "additional_requirements": "Are there any additional project requirements to follow; is this an historic renovation? Are there landmark requirements?",
                    "architectural_details": "Are there architectural details to show the existing wall conditions <span class=\"italic\">(either or both the original drawings and current drawings would be helpful)</span>?",
                    "attick_stock": "Are there attic stock requirements; and if so, what are they? ",
                    "building_rules": "What are the building rules? Work hours? Is there an elevator present and usable? If so, what is the size of this elevator (including door opening dimensions)?",
                    "composites": "When looking at the composites, what is the site maneuverability. Just because we can mull them in the factory doesn't mean that will work on the site (tight hallways or stairwells, etc).",
                    "conditioners_questions": "Are there through-window Air Conditioners in place or will they be needed on the project? If so, what is the anticipated detail or installation expectation? If there are Air Conditioners to be used, find out the models and dimensions of sleeve.",
                    "delivery_questions": "We deliver a container, and you have 4 hours to unload it. Where will the windows be stored? Is there a basement or common area where you can stage them all? What will the delivery location be (curbside, loading dock, etc)?",
                    "expected_exterior_finish": "What are the expected exterior finish details? Who will be providing exterior closure trim or accessories? <span class=\"italic\">Please provide sketches or details of necessary trim items for quoting and drawing coordination (include anticipated measurements).</span>",
                    "expected_interior_finish": "What are the expected interior finish details? Who will be providing interior closure trim or accessories? Will existing interior conditions remain or expected to be replaced? <span class=\"italic\">Please provide sketches or details of necessary trim items for quoting and drawing coordination (include anticipated measurements).</span>",
                    "expected_timeline": "What is the expected project timeline and when would windows be needed?",
                    "field_measuring": "Who will be responsible for field measuring all units and providing the final window count?",
                    "frames_questions": "Are the existing master frames remaining or will this be a ‘total-rip’ installation? What is the preferred method of installation (clip, jump frame/flush flange, etc)?",
                    "how_much_work": "How much work is being done? Is this just a window replacement or will there be additional exterior and interior work?",
                    "installer": "Who will be providing the installation on this project? <span class=\"italic\">(if approached by the building stakeholders)</span>",
                    "occupied_or_vacant": "Will the work be performed in occupied units, or will the building be vacant?",
                    "scaffolding": "Will there be scaffolding in place? <span class=\"italic\">Will work be done from the interior or exterior?</span>",
                    "service_questions": "What do they do currently for service? Is there a building super who makes minor repairs, or do they call a third-party company?",
                    "who_is_client": "Who is the client on the project? Residents often will want their own options, meaning different hardware finishes per apartment, etc. So how will this be presented regarding options? Will it be a unilateral decision?"
                },
                "text_with_attachments": {
                    "attachments": "Add Attachments"
                },
                "text_with_images": {
                    "images": "Add Image"
                },
                "training_summary": "Training Summary",
                "training_summary_explanation": "Give a detail account of your experience at job site and training completed.",
                "upcoming_projects_and_referrals": "Upcoming Projects & Referral Contacts",
                "upcoming_projects_and_referrals_additional_docs": "Additional Documents/Videos/Images",
                "upcoming_projects_and_referrals_explanation": "Please complete the referral report. This information will not be included in the report for the client.",
                "upcoming_projects_and_referrals_images": "Referral reporting images",
                "upcoming_projects_and_referrals_title": "Internal Details Below Not Visible In PDF Report",
                "update": "Update",
                "windows_installed": "Percent of Windows Installed"
            },
            "reports": {
                "statuses": {
                    "draft": "Draft",
                    "report_approved": "Report Approved",
                    "report_canceled": "Report Canceled",
                    "report_declined": "Report Declined",
                    "report_submitted": "Report Submitted"
                }
            },
            "statuses": {
                "service_canceled": "Service Canceled",
                "service_finished": "Service Finished",
                "service_started": "Service Started",
                "submitted": "Submitted"
            },
            "system": {
                "appointment": {
                    "already_finished": "Service Appointment already finished!",
                    "canceled": "Service Appointment was successfully canceled.",
                    "failed": "Failed to save Service Appointment!",
                    "saved_successfully": "Service Appointment was saved successfully",
                    "wrong_stage": "Service Appointment can not be changed at this stage!"
                },
                "list": {
                    "export_failed": "Service Appointment list export failed due to system error. Please, try again or contact IT if problem persists.",
                    "get_failed": "Failed to retrieve Service Appointment list. Please, try again or contact IT if problem persists."
                },
                "report": {
                    "approved": "Service Appointment Report was successfully approved.",
                    "canceled": "Service Appointment Report was successfully canceled.",
                    "declined": "Service Appointment Report was successfully declined.",
                    "failed": "Failed to save Service Appointment Report!",
                    "position_different_order": "QR Code is from a different order!",
                    "position_different_project": "QR Code is from a different project!",
                    "position_not_found": "No position was found with given QR Code!",
                    "saved_successfully": "Service Appointment Report was saved successfully.",
                    "submitted": "Service Appointment Report was successfully submitted.",
                    "wrong_stage": "Service Appointment Report can not be changed at this stage!"
                },
                "service_time": {
                    "failed": "Failed to save Service Appointment!",
                    "timer_finished": "Service Appointment Timer finished",
                    "timer_started": "Service Appointment Timer started",
                    "wrong_status": "Service Appointment has wrong status. Cannot start the Timer!"
                },
                "ticket": {
                    "not_found": "ZOHO Desk Ticket was not found"
                }
            },
            "types": {
                "acm": "ACM",
                "delivery_inspection": "Delivery Inspection",
                "field_test": "Field Test",
                "general_service": "General Service",
                "installation_training": "Installation Training",
                "meeting": "Meeting",
                "other_custom": "Other (Custom)",
                "pto": "PTO",
                "retrofit_inspection": "Retrofit Inspection",
                "training": "Training",
                "travel_out_of_market": "Travel: Out Of Market",
                "vehicle_maintenance": "Vehicle Maintenance"
            }
        },
        "system": {
            "email": {
                "cannot_log_sending": "Cannot save log entry for email sending"
            },
            "file": {
                "access_denied": "You do not have an access to this file!",
                "loading": "Loading",
                "no_download_url": "Error: file cannot be loaded. No download url provided.",
                "not_found": "Requested file not found on server."
            },
            "page": {
                "access_denied": {
                    "back_button_title": "Back to Home",
                    "description": "Please submit ticket for the support team if the access to the destination page is required.",
                    "title": "Access denied!"
                },
                "not_found": {
                    "back_button_title": "Back to Home",
                    "description": "The page you were looking for was not found. Please check the address and if that does not help, please submit ticket for the support team.",
                    "title": "Page Not Found!"
                },
                "system_error": {
                    "back_button_title": "Back to Home",
                    "description": "Unexpected system error has occurred. Please submit ticket for the support team if the problem persists.",
                    "title": "Internal Server Error!"
                }
            }
        },
        "admin": {
            "synchronizations": {
                "alpha": "Alpha",
                "azure": "Azure",
                "cache": "Cache",
                "cache_clear": "Clear cache",
                "media": "Media",
                "media_clear_processing": "Delete processing documents",
                "send_in_blue": "SendInBlue",
                "synchronize_alpha_users": "Synchronize users",
                "synchronize_group_members": "Synchronize group members",
                "synchronize_groups": "Synchronize groups",
                "synchronize_sendinblue_templates": "Synchronize SendInBlue templates",
                "synchronize_user_pictures": "Synchronize user profile pictures",
                "synchronize_user_pictures_warning": "This operation takes a long time to finish.",
                "synchronize_users": "Synchronize users"
            }
        },
        "media": {
            "processing": {
                "failed_to_save": "Failed to save Media Processing entry."
            }
        },
        "pagination": {
            "next": "Next &raquo;",
            "previous": "&laquo; Previous"
        },
        "menu_items": {
            "admin": "Administration",
            "admin_synchronizations": "Synchronizations",
            "bluescreen": "BlueScreen",
            "cross-checking": "Cross-Check",
            "cross-checking-checklist": "Checklist",
            "cross-checking-classifications": "Classifications",
            "dashboard": "Dashboard",
            "factory-tests": "Factory Tests",
            "factory-tests-dashboard": "Factory Tests Dashboard",
            "factory-tests-testing-subjects": "Testing Subject Management",
            "priority_settings_management": "Priority Management",
            "quality-assurance-dashboard": "Quality Assurance Dashboard",
            "request_duration_management": "Requests Duration Management",
            "service_appointments": "Field Service Management",
            "service_appointments_calendar": "Service Calendar",
            "service_appointments_list": "Service Appointment List",
            "service_appointments_reports": "Service Reports",
            "shop_drawings": "Shop Drawings",
            "shop_drawings_dashboard": "Shop Drawings Dashboard"
        },
        "permissions_subcategories": {
            "general": "General"
        },
        "cross_checking": {
            "classification": "Classification",
            "delete": "Remove",
            "item_name": "Checklist Item",
            "name": "Name",
            "request_types": "Request Type"
        },
        "permissions": {
            "groups": {
                "create": "Create groups",
                "delete": "Delete groups",
                "update": "Update groups",
                "view": "View groups",
                "view_all": "View all groups"
            }
        },
        "quality_assurance": {
            "delivery": "Delivery",
            "edit_modal": {
                "air_allowable": "Allowable (cfm/sq.sf)",
                "air_infiltration": "Air Infiltration (PSFs)",
                "air_test_results": "Test Results value (PSFs)",
                "allowable": "Allowable",
                "attachments": "Attachments",
                "cancel": "Cancel",
                "cancel_button": "Cancel Test",
                "canceled_reason": "Please provide a reason for cancellation",
                "complete": "Complete",
                "created_by": "Created By",
                "delivery": "Delivery",
                "fill_mandatory_fields": "Some of the fields are missing or invalid",
                "fill_mandatory_reason": "Mandatory reason field is missing",
                "images": "Images",
                "initial_status": "Draft",
                "modal_title": "Quality Assurance",
                "no_order": "No orders were found containing given search term",
                "no_project": "No projects were found containing given search term",
                "notes": "Notes",
                "order": "Order",
                "project": "Project",
                "reason": "Reason",
                "request_canceled": "Request was cancelled by {name} {at}",
                "save_as_draft": "Save as Draft",
                "select_order": "Select Order",
                "select_project": "Select Project",
                "select_test_type": "Select Test Type",
                "showing_top_results": "Showing top {top} results",
                "test": "Pass/Fail",
                "test_date_time": "Date and Time",
                "test_psf": "Test PSFs",
                "test_result_comment": "Comment",
                "test_results": "Test Results",
                "test_results_value": "Test Results Value",
                "test_type": "Test Type",
                "update": "Update",
                "water_allowable": "Allowable",
                "water_infiltration": "Water Penetration (PSFs)",
                "water_test_results": "Test Results value (PSFs)"
            },
            "filters": {
                "close": "Close",
                "filter": "Filter",
                "passed_title": "Results",
                "statuses_title": "Status",
                "test_types_title": "Test Type",
                "title": "Filters"
            },
            "list": {
                "actions": "Actions",
                "add_new": "Add Test",
                "add_new_with_qr": "Add Test From QR",
                "applied_filters": "Applied Filters",
                "column_passed_title": "Result",
                "no_records": "No Records",
                "of": "of",
                "open_service": "Open Quality Assurance",
                "show_num": "Show",
                "title": "Quality Assurance List",
                "view_item": "View Quality Assurance Report"
            },
            "number": "Number",
            "order_name": "Order",
            "passed": "Passed",
            "project_name": "Project",
            "responses": {
                "canceled": "Quality Assurance Canceled",
                "completed": "Quality Assurance Completed",
                "list_failed": "Failed to get Quality Assurance List",
                "saved_successfully": "Quality Assurance Saved Successfully"
            },
            "saving": {
                "failed": "Quality Assurance Saving Failed"
            },
            "status": {
                "wrong": "Quality Assurance has wrong status for that action"
            },
            "test": {
                "failed": "Failed",
                "passed": "Passed"
            },
            "test_time": "Date and Time",
            "test_type": "Test Type"
        },
        "home": {
            "to_intus_erp": "To Intus ERP",
            "welcome": "Welcome"
        },
        "proposals": {
            "types": {
                "alternative": "Alternative",
                "c_inventory": "C-Inventory",
                "claim": "Claim",
                "continuation_of_existing_order": "Continuation of Existing Order",
                "continuation_of_existing_order_active": "Continuation of Existing Order (Active)",
                "inventory": "Inventory",
                "main": "Main",
                "main_active": "Main (Active)",
                "marketing": "Marketing",
                "performance_mockup": "Performance Mockup",
                "submittals": "Submittals",
                "testing": "Testing",
                "visual_mockup": "Visual Mockup"
            }
        },
        "permissions_categories": {
            "groups": "Groups"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "testing-subjects": {
            "actions": "Actions",
            "delete": "Remove Testing Subject",
            "disable": "Disable",
            "enable": "Enable",
            "name": "Name",
            "save_testing_subject": "Save"
        },
        "shop_drawings": {
            "action_required": {
                "answer_rfi": "Answer RFI",
                "approve_or_reject": "Approve or Reject",
                "assign_drafter": "Assign Drafter",
                "installation_details": "Upload Installation Details",
                "new_request": "New Request",
                "prepare_drawings": "Prepare Drawings",
                "request_for_shops": "Request for Shops",
                "review": "Review the Draft",
                "review_drawings": "Review Drawings",
                "revision_on_hold": "Confirm details",
                "shop_drawing_for_production": "Upload Production Shops",
                "start_processing": "Start processing",
                "submit_to_drafter": "Submit to Drafter",
                "upload_draft": "Upload Draft"
            },
            "additional_request": {
                "assigned_to": "Assigned to",
                "attachments": "Attachments",
                "buttons": {
                    "assign_drafter": "Assign drafter",
                    "cancel": "Cancel",
                    "edit": "Edit",
                    "save": "Save",
                    "upload": "Upload"
                },
                "cancelled": "Canceled",
                "default_notes": {
                    "installation_details": "See prepared installation details",
                    "shop_drawing_for_production": "See prepared production shop drawings"
                },
                "due_date": "Due Date",
                "enter_notes_and_file": "Please enter some notes and add a file before submit",
                "note": "Note",
                "requested_by": "Requested By",
                "requests": {
                    "installation_details": "Installation Details Request",
                    "shop_drawing_for_production": "Production Shops Request"
                },
                "reviewed": "Reviewed",
                "types": {
                    "installation_details": "Installation Details",
                    "shop_drawing_for_production": "Production Shops"
                },
                "uploaded_by": "Uploaded By",
                "uploads": {
                    "installation_details": "Installation Details",
                    "shop_drawing_for_production": "Production Shops"
                }
            },
            "assign_drafter": {
                "fill_mandatory_fields": "Some of the \"Task Information\" fields entries are missing"
            },
            "cad_generation": {
                "modal_title": "3D Cad Generation is in progress"
            },
            "canceled_shops": {
                "canceled_by": "Canceled by",
                "reason": "Reason for Cancellation"
            },
            "dashboard": {
                "filters": {
                    "close": "Close",
                    "drafter": "Drafter",
                    "filter": "Filter",
                    "include_linked_requests": "Include Linked Requests",
                    "po_owner": "PO Owner",
                    "project_estimator": "Project Estimator",
                    "request_type": "Request Type",
                    "status": "Status",
                    "title": "Filters"
                },
                "list": {
                    "applied_filters": "Applied Filters",
                    "filters": "Filters"
                }
            },
            "draft": {
                "note_added_on": "Note added on",
                "notes": {
                    "draft_submitted": "Draft submitted"
                },
                "statuses": {
                    "approved": "Approved",
                    "pending": "Pending",
                    "rejected": "Rejected",
                    "submitted": "Submitted"
                },
                "submittedon": "Submitted on",
                "turnaround_time": "Turnaround time"
            },
            "dwg_generation": {
                "button": "Download DWG & PDF",
                "modal_title": "DWG Document Generation is in progress"
            },
            "header": {
                "assign_drafter": "ASSIGN DRAFTER",
                "cancel_request": "Cancel Request",
                "created_by": "Created by",
                "created_on": "Created on",
                "download_xlsx_for_cad": "Download XLSX for CAD",
                "go_to_3d_cad_automation": "go to 3d cad automation",
                "installation_details": "Request Installation Details",
                "more": "MORE",
                "open_3d_cad": "open 3d cad",
                "phase": "phase",
                "phase_capitalized": "Phase",
                "phase_uppercase": "PHASE",
                "put_on_hold": "Hold",
                "request": "REQUEST",
                "request_for_revision": "REQUEST FOR REVISION",
                "request_for_shops": "REQUEST FOR SHOPS",
                "rfi": "RFI",
                "save_or_cancel_changes": "Please save or cancel your task information changes",
                "shop_drawing_for_production": "Request Production Shops",
                "start_processing": "START PROCESSING",
                "submit_to_drafter": "SUBMIT TO DRAFTER",
                "unhold_to": "Restore to ",
                "upload_signed_shops": "Upload Signed Shops"
            },
            "hold_status": {
                "inst_details_are_being_prepared": "Inst. Details are being prepared",
                "installation_details_are_being_checked": "Drawings are being checked",
                "linked_inst_details_request_on_hold": "Linked Inst. Details request On Hold",
                "other": "Other",
                "other_internal_reasons": "ON INTUS. Other internal reasons",
                "product_development_questions": "Product development questions",
                "quote_expired": "Quote Expired, to be updated",
                "quote_to_be_updated_due_to_changes_in_installation_details": "Quote to be updated due to changes in installation details",
                "shop_requirements_are_changing": "ON CLIENT. Shop Requirements (quote) is changing/ Client is reviewing RFI",
                "switched_to_higher_priority_request": "Switched to higher priority request."
            },
            "list": {
                "action_due": "Action Due",
                "action_required": "Action Required",
                "action_required_capitalized": "Action Required",
                "action_required_uppercase": "ACTION REQUIRED",
                "all_statuses_selected": "All",
                "assigned_to_me": "Assigned to me",
                "bd": "PO Owner",
                "cross_checked_by": "Cross-Checked By",
                "difficulty_level": "Difficulty",
                "drafter": "Drafter",
                "export_excel": "Export Excel",
                "is_new": "Is New",
                "my_shops": "My Shops",
                "no_records": "No Records",
                "none_statuses_selected": "None",
                "number_heading": "Project No.",
                "of": "of",
                "planned_due_date": "Est. Completion Date",
                "pm": "Project Estimator",
                "priority": "No.",
                "priority_button_edit": "Edit priority",
                "priority_button_edit_capitalized": "Edit Priority",
                "priority_button_edit_uppercase": "EDIT PRIORITY",
                "project_name": "Project Name",
                "project_no": "Project No.",
                "proposal_type": "Proposal Type",
                "request": "Request Date",
                "request_type": "Request Type",
                "requested_by": "Requested By",
                "requesting": "Request",
                "search": "Search",
                "select_all_statuses": "All",
                "shop_drawings_list_capitalized": "Shop Drawings List",
                "shop_drawings_list_uppercase": "SHOP DRAWINGS LIST",
                "show_num": "Show ",
                "status": "Status",
                "submitted_for_drafter": "Submitted for Drafter",
                "suggested_due_date": "Requested Due Date",
                "unassigned": "Unassigned",
                "update_est_dates_button": "Update Est. Dates",
                "workload": "Workload"
            },
            "modal": {
                "additional_request": {
                    "buttons": {
                        "upload_additional": "Upload Additional"
                    },
                    "errors": {
                        "dwg_required": "T.DWG file required as attachment",
                        "required_field": "This field is required"
                    },
                    "note_placeholder": "Note"
                },
                "cancel": {
                    "buttons": {
                        "cancel": "No",
                        "save": "Yes"
                    },
                    "note": "Note: This action can not be undone. In case this request will be continued revision can be requested via action \"Request for Revision\".",
                    "note_placeholder": "Reason for Cancellation",
                    "pm_rejection_note": "Rejection can be applied only when there's an issue from a drafter side.",
                    "question": "Do you really want to Cancel shop drawing request?",
                    "title": "Cancel Shop Drawing Request"
                },
                "cancel_additional_request": {
                    "buttons": {
                        "cancel": "No",
                        "save": "Yes"
                    },
                    "errors": {
                        "required_field": "This field is required"
                    },
                    "note": "Note: This action can not be undone. Once request will be cancelled new request can be created under option \"More\".",
                    "note_placeholder": "Reason for Cancellation",
                    "question": "Do you really want to Cancel",
                    "title": "Cancel"
                },
                "canceled": {
                    "errors": {
                        "required_field": "This field is required"
                    }
                },
                "hold": {
                    "buttons": {
                        "cancel": "Cancel",
                        "save": "Hold"
                    },
                    "date_placeholder": "Select Due Date",
                    "due_date_label": "Due Date for Status",
                    "errors": {
                        "required_field": "This field is required"
                    },
                    "hold_status_placeholder": "Select hold reason",
                    "note_placeholder": "Specify reason",
                    "reason_label": "Reason",
                    "status_label": "Select reason",
                    "title": "Put on Hold"
                },
                "revision_draft": {
                    "additional_files": "Additional Files",
                    "buttons": {
                        "add_file": "Add File",
                        "cancel": "No",
                        "save": "Yes",
                        "upload": "Add Draft File",
                        "upload_additional": "Add attachments"
                    },
                    "errors": {
                        "dwg_required": ".DWG file required as attachment"
                    },
                    "installation_details_input_label": "New Installation Details created",
                    "installation_details_revised_input_label": "Installation Details Revised",
                    "metal_profiles_details": "Metal Profiles Details",
                    "modal_title": "Upload & Submit",
                    "new_positions_input_label": "New Positions",
                    "resubmit_header": "Re-Submit following request",
                    "revised_positions_input_label": "Revised Positions",
                    "upload_draft": "Upload Draft"
                },
                "shops_used_for_order": {
                    "buttons": {
                        "cancel": "CANCEL",
                        "proceed": "PROCEED"
                    },
                    "message": "Attention! Shop drawings for production is already used for Order {order_link}. Do you want to proceed with new request?",
                    "title": "Attention!"
                },
                "signed": {
                    "buttons": {
                        "cancel": "Cancel",
                        "save": "Save",
                        "upload": "Add signed Shop Drawings"
                    },
                    "errors": {
                        "required_field": "This field is required"
                    },
                    "note_placeholder": "Note",
                    "title": "Upload Signed Shops"
                }
            },
            "new_request": {
                "button_init": "New Request",
                "modal": {
                    "button_cancel": "Cancel",
                    "button_create": "Create New Request",
                    "text": "Please make sure that you are not duplicating request. Do you really want to create separate request?",
                    "title": "New Request"
                }
            },
            "page": {
                "title": "Shop Drawings",
                "title_revision": ": Revision {no}"
            },
            "priority_modal": {
                "cancel_uppercase": "CANCEL",
                "edit_priorities_capitalized": "Edit priorities",
                "no_select_options": "No Options",
                "priority": "Priority",
                "priority_capitalized": "No.",
                "project_name_capitalized": "Project name",
                "proposal_name_capitalized": "Proposal name",
                "save_uppercase": "SAVE",
                "see_time_line": "SEE TIMELINE",
                "time_line": {
                    "close": "Close",
                    "show_more": "Show More"
                },
                "time_line_modal_title": "Timeline for Action Required Priority"
            },
            "project_info": {
                "address": "Address",
                "amount": "Amount",
                "architect": "Architect",
                "bd": "PO Owner",
                "building_classification": "Building Classification",
                "building_height": "Building Height",
                "building_length": "Building Length",
                "building_width": "Building Width",
                "cis_button": "CIS",
                "client_company_name": "Client company name",
                "construction": "Construction",
                "crm_button": "CRM",
                "design_criteria": "Design Criteria",
                "exposure_classification": "Exposure Classification",
                "general_contractor": "General Contractor",
                "general_information": "General Information",
                "link_requests_button": "Link Requests",
                "link_requests_modal": {
                    "already_linked_request_attention_message": "Attention! Already linked request selected. Newly selected request will overwrite linkage.",
                    "cancel_button": "Cancel",
                    "link_button": "Link",
                    "link_request_to": "Link Request To",
                    "select_request": "Select Request",
                    "select_request_placeholder": "Select Request you would like to link",
                    "selected_linked_request_on_hold_attention_message": "Attention! Selected request is on Hold. Linkage modification is disabled for on hold status requests",
                    "title": "Link Request"
                },
                "linked_npd_tickets": "Linked NPD Tickets",
                "linked_requests": "Linked Requests",
                "opportunity": "Project opportunity",
                "pc": "Project Estimator",
                "project_requests": "Single Project Requests",
                "stage": "Stage",
                "unique_positions": "Unique positions",
                "wind_load": "Wind Load",
                "wind_speed": "Wind Speed",
                "zone_4_custom": "Custom (Zone 4)",
                "zone_4_negative": "Zone 4 (negative)",
                "zone_4_positive": "Zone 4 (positive)",
                "zone_5_custom": "Custom (Zone 5)",
                "zone_5_negative": "Zone 5 (negative)",
                "zone_5_positive": "Zone 5 (positive)"
            },
            "request_for_revision": {
                "fill_mandatory_fields": "Please fill all mandatory fields before Request for Revision!"
            },
            "request_types": {
                "elevations_pre_shops": "Elevations (Pre-Shops)",
                "initial": "Request",
                "inst_details": "Inst. Details",
                "inst_details_for_prod": "Inst. Details (for PROD)",
                "inst_details_pre_shops": "Inst. Details (Pre-Shops)",
                "shop_drawings": "Shop Drawings",
                "shops_for_prod": "Shops for Prod"
            },
            "revision": "revision",
            "revision_drafts": {
                "actions": "Actions",
                "add_note": "ADD NOTE",
                "approve_capitalized": "Approve",
                "approve_uppercased": "APPROVE",
                "approved_capitalized": "Approved",
                "approved_on": "Approved on",
                "approved_on_capitalized": "Approved on",
                "approved_successfully": "Shop Drawings draft was approved successfully",
                "approved_uppercased": "APPROVED",
                "cancel": "CANCEL",
                "canceled_successfully": "Shop Drawings draft was canceled successfully",
                "document_name": "Document name",
                "download_uppercased": "DOWNLOAD",
                "drafter": "Drafter",
                "enter_notes": "Please enter some notes",
                "enter_notes_and_file": "Please enter some notes and add a file before submit",
                "enter_notes_before_submit": "Please enter some notes before submit",
                "id": "ID",
                "inst_details_header": "New Inst. Details",
                "inst_details_revised": "Inst. Details Revised",
                "new_positions_header": "New Positions",
                "note": "Note",
                "quote": "Quote",
                "quote_adjustments_needed": "Quote Adjustments Needed",
                "reject_capitalized": "Reject",
                "reject_reason": "Reject Reason",
                "reject_uppercased": "REJECT",
                "rejected_capitalized": "Rejected",
                "rejected_on_capitalized": "Rejected on",
                "rejected_successfully": "Shop Drawings draft was rejected successfully",
                "rejected_uppercased": "REJECTED",
                "revised_positions_header": "Revised Positions",
                "select_reason": "Select reason",
                "submit": "SUBMIT",
                "submit_capitalized": "Submit",
                "submit_default_note": "See prepared request",
                "submit_or_cancel_draft": "Draft is already uploaded, please submit or cancel existing one",
                "submitted_on": "Submitted on",
                "submitted_successfully": "Shop Drawings draft was submitted successfully",
                "submitter": "Submitter",
                "upload": "Upload & Submit",
                "upload_draft": "Upload & Submit",
                "upload_failed": "Shop Drawings draft upload failed",
                "uploaded_successfully": "Shop Drawings draft was uploaded successfully"
            },
            "revision_drafts_note_modal": {
                "cancel": "Cancel",
                "note_input_name": "Note",
                "note_input_placeholder": "Please enter some notes",
                "submit": "Add Note",
                "submitted_successfully": "Note Added",
                "title": "Add Note"
            },
            "signed_shops": {
                "note": "Note",
                "signed_shops": "Signed Shops",
                "uploaded_by": "Uploaded by"
            },
            "statuses": {
                "being_processed": "Being Processed",
                "canceled": "Canceled",
                "completed": "Completed",
                "done": "Done",
                "draft": "Draft",
                "hold": "On Hold",
                "pending": "Pending",
                "request_sent_to_pc": "Request Sent to PC",
                "revision_sent_to_pc": "Revision Sent to PC",
                "under_pc_review": "Under PC Review"
            },
            "system": {
                "additional_request": {
                    "cancelled_successfully": "Cancelled Successfully",
                    "created_successfully": "Request created successfully",
                    "drafter_assigned_successfully": "Drafter assigned successfully",
                    "submitted_successfully": "Request submitted successfully",
                    "upload_failed": "File upload failed. Please try again"
                },
                "approve_reject_draft": {
                    "already_approved_rejected": "Shop Drawings draft is already approved or rejected!",
                    "not_submitted": "Shop Drawings draft is not submitted!",
                    "wrong_stage": "Shop Drawings draft cannot be approved or rejected at this stage!"
                },
                "assign_drafter": {
                    "failed": "Failed to request for Shop Drawings!",
                    "fill_mandatory_fields": "Some of the \"Task Information\" fields entries are missing",
                    "successfully": "Shop Drawings request sent for assigned drafter",
                    "wrong_stage": "Request for Shop Drawings cannot be triggered at this stage!"
                },
                "attach_file": {
                    "cannot_upload_shops_for_production": "Attention! Shop drawings for production are already uploaded. If new shop drawings has to be uploaded, please contact purchase manager.",
                    "invalid_data": "System does not support this document format. Available formats - {extensions}",
                    "upload_failed": "File upload failed. Please try again"
                },
                "cancel_draft": {
                    "already_submitted": "Shop Drawings draft is already submitted!",
                    "wrong_stage": "Shop Drawings draft cannot be canceled at this stage!"
                },
                "canceled": {
                    "already_canceled": "Shop Drawing request is already canceled!",
                    "failed": "Failed to cancel Shop Drawings!",
                    "successfully": "Shop Drawings request canceled successfully"
                },
                "drafter_has_being_processed": "{drafter} is working on another 'Being Process' status request.",
                "hold": {
                    "already_hold": "Shop Drawing request is already on hold!",
                    "failed": "Failed to hold Shop Drawings!",
                    "successfully": "Shop Drawings request hold successfully"
                },
                "request_for_revision": {
                    "failed": "Failed to request for Shop Drawings Revision!",
                    "successfully": "Request for Shops Revision has been sent successfully",
                    "wrong_stage": "Request for Shop Drawings Revision cannot be triggered at this stage!"
                },
                "request_for_shops": {
                    "failed": "Failed to request for Shop Drawings!",
                    "successfully": "Request for Shops has been sent successfully",
                    "wrong_stage": "Request for Shop Drawings cannot be triggered at this stage!"
                },
                "signed": {
                    "already_canceled": "Shop Drawings request is Canceled! To proceed request for revision is required",
                    "already_done": "Signed Shop Drawings are already uploaded!",
                    "failed": "Failed to save signed Shop Drawings!",
                    "uploaded_successfully": "Signed Shop Drawings were uploaded successfully"
                },
                "submit_draft": {
                    "already_submitted": "Shop Drawings draft is already submitted!",
                    "wrong_stage": "Shop Drawings draft cannot be submitted at this stage!"
                },
                "submit_to_drafter": {
                    "failed": "Failed to submit Shop Drawings to Drafter!",
                    "fill_mandatory_fields": "Some of the \"Task Information\" fields entries are missing.",
                    "same_request_phase_type_request": "Attention! Request with the same phase/proposal type and request type already exists. Duplicated request cannot be submitted for Drafters",
                    "same_request_type_request": "Attention! Request with the same proposal type and request type already exists. Duplicated request cannot be submitted for Drafters",
                    "successfully": "Request successfully submitted to Drafter",
                    "wrong_stage": "Request for Shop Drawings cannot be triggered at this stage!"
                },
                "task_info": {
                    "already_done": "Shop Drawings request is Done/Canceled. Task information cannot be edited",
                    "failed": "Failed to save Shop Drawings task information changes!",
                    "successfully": "Task information was saved successfully"
                },
                "unhold": {
                    "already_unhold": "Shop Drawing request is already not on hold!",
                    "failed": "Failed to unhold Shop Drawings!",
                    "successfully": "Shop Drawings request unhold successfully"
                },
                "upload_draft": {
                    "wrong_stage": "Shop Drawings draft cannot be uploaded at this stage!"
                }
            },
            "task_info": {
                "architectural_drawing_set": "Architectural Drawing Set",
                "authorized_buyer_name": "Authorized Buyer Name",
                "authorized_buyer_title": "Authorized Buyer Title",
                "before_hold_status": "Status before hold:",
                "buttons": {
                    "attach_file": "Attach File",
                    "cancel": "CANCEL",
                    "edit": "EDIT",
                    "save": "SAVE"
                },
                "cross_check_duration": "Cross-Check Duration (hours)",
                "cross_checked_by": "Cross-Checked By",
                "cross_checked_by_attachments": "Attachments",
                "date_placeholder": "Select date",
                "difficulty_level": "Difficulty Level",
                "drafter": "Drafter",
                "due_date_note": "Note for Due Date",
                "expected_duration": "Expected Duration (hours)",
                "header": "Task Information",
                "hold_due_date": "Due Date",
                "hold_reason": "On Hold Reason",
                "hold_status": "Hold reason",
                "installation_details": "Inst. Details Sets",
                "installer": "Installer",
                "installer_default_value": "N.P",
                "leed_project": "LEED Project",
                "linked_orders": "Linked Orders",
                "linked_request_being_processed": "Linked Request status is 'Being Processed', update is disabled",
                "linked_request_under_pc_review": "Linked Request status is 'Under PC Review', update is disabled",
                "modified_by": "Modified By",
                "on_hold_by": "On Hold by",
                "planned_due_date": "Est. Completion Date",
                "project_specific_requirements": "Project Specific Requirements",
                "proposal_link": "Link to the proposal",
                "quote": "Quote",
                "quote_comparison": {
                    "create_job_failed": "Failed to create job to export quote comparison",
                    "fetch_job_failed": "Failed to fetch quote comparison export job details",
                    "file_download_failed": "Failed to download quote comparison file",
                    "label": "Quote Comparison",
                    "not_available": "No Data Available"
                },
                "request_date": "Request Date",
                "request_type": "Request Type",
                "requirements": "Request Requirements",
                "requirements_attachments": "Shop Drawing Requirements Attachments",
                "selected_quote_mismatch": "<b>Attention!</b> Selected Quote does not match linked request quote!",
                "selected_quote_revised": "<b>Attention!</b> BlueScreen request is revised. Please confirm with Estimator!",
                "submitted_for_drafter": "Submitted for Drafter",
                "suggested_due_date": "Suggested Due Date",
                "tooltip_new_shop_drawings": "10 business days drawing preparation+ 2 business days PC review",
                "tooltip_revision_of_shop_drawings": "4 Business days drawing preparation + 2 business days PC Review",
                "upload_in_progress": "Please wait until the file upload is finished"
            },
            "update_est_dates_modal": {
                "button_close": "Close",
                "button_start": "Start Calculation",
                "confirmation_text": "Do you want to recalculate all active requests' Est. Completion Dates?",
                "success_text": "Est. Completion Dates Recalculated",
                "title": "Est. Dates Calculation"
            },
            "vue": {
                "new": "NEW",
                "revision_initial": "First Time",
                "revision_num": "Revision {no}"
            }
        },
        "references": {
            "care_and_maintenance": {
                "educate_and_explain": "Educate and explain product adjustments.",
                "index": "Care & Maintenance",
                "operational_steps_maintenance_obligations": "Advice of operational steps and maintenance obligations required regarding the installed products.",
                "product_operations": "Review product operations with installers and GC.",
                "qr_codes": "Review and demonstrate how to properly use QR codes and features of QR codes.  Advise to leave QR codes on for the life of the product.",
                "sash_removal": "Review sash removal and replacement (windows, hinged doors, sliding doors)."
            },
            "delivery_handling_and_storage": {
                "accessible_route": "Have accessible routes to rough openings and storage locations.",
                "doors_and_windows": "Products should be handled with clean hands and equipment.",
                "glass_stored": "Windows/doors, sashes, and glass must be stored in a vertical upright position.",
                "index": "Delivery, Handling & Storage",
                "job_site_condition": "Review job-site conditions, store items in secure location.",
                "proper_equipment": "Proper equipment and tools for unloading and maneuvering products.",
                "protect_windows": "Protect interior and exterior of products from contact with harsh chemicals, construction material contamination, moisture, and hot work.",
                "signs_of_damage": "Check signs of damage and report any damages found ASAP. Remind site they have 15 days to report any shipping damages.",
                "storage_area": "Pre-installed products must be stored on level surface in a dry, well-ventilated area, out of the direct elements, and away from active construction."
            },
            "ez_mullion": {
                "additional_sealant": "Apply additional sealant along the top and bottom of the mullion connection and tool as needed.",
                "apply_silicone_in_3rd_location": "Apply silicone in 3rd location prior to setting reinforcement “A” to EZ mullion “A” once EZ mullion is set onto window frame.",
                "apply_silicone_two_locations": "Apply silicone in two locations along the full length of EZ mullion “A” prior to setting onto window frame.",
                "apply_silicone_under_shims": "Apply silicone under shims to secure them into place at the correct spacing.",
                "index": "EZ Mullion",
                "install_cover": "Install EZ mullion cover cap and review when to install/final sealant.",
                "position_ez_mullions": "Position EZ mullion “A” shims spaced (8”) from ends and (11- 13/16”) in between shims.",
                "screw_ez_mullion_a": "Screw EZ mullion and reinforcement “A” onto window using the 4.8 x 38 mm self-tapping screw. Ensure reinforcement and mullion are seated properly.",
                "screw_ez_mullion_b": "Screw EZ mullion and reinforcement “B” onto window using the 4.8 x 38 mm self-tapping screw. Ensure reinforcement and mullion are seated properly.",
                "screw_reinforcement": "Screw both reinforcement “A” and reinforcement “B” together from the interior using the 4.8 x 19 mm self-taping screw.",
                "shims_spaced": "Position EZ mullion “B” shims spaced (8”) from corners and (11 -13/16”) in between corner shims.",
                "silicone_in_2nd_location": "Apply silicone in 2nd location of EZ mullion “B” once EZ mullion and reinforcement “B” are secured to window frame.",
                "silicone_in_one_location": "Apply silicone in 1 location along the full length of the EZ mullion “B” prior to setting onto window frame.",
                "silicone_under_shims": "Apply silicone under shims to secure them into place at the correct spacing.",
                "slide_and_interlock": "Slide and interlock both EZ mullion “A” and EZ mullion “B” together so both reinforcements interlock properly.",
                "three_locations_of_silicone": "Apply three locations of silicone on EZ mullion “A” prior to setting 2 windows together."
            },
            "factory_test_field_inspection": {
                "aluminum_flange_perimeter": "Aluminum flange has perimeter sealant at the flange-to-frame location",
                "connecting_mullions_sealed": "Connecting mullions are properly sealed at the top and bottom",
                "door_sash_adjusted": "The door sash is properly adjusted so that the gasket is overlapped on all 4 sides",
                "equal_overlap": "Sash has equal overlap from all sides",
                "equalization_exterior": "Equalization holes are in the right places and in the right quantity from exterior",
                "equalization_interior": "Equalization and weep holes are in the right places and in the right quantities from interior",
                "gasket_soft_clean": "Gasket is soft and clean",
                "glazing_beads_reinstalled": "If glazing beads were removed and reinstalled, or have gaps in the corners, seal connecting corners of glazing beads",
                "glazing_shims": "Glazing shims are not blocking weep holes or equalization holes",
                "glazing_stops": "If glazing stops were reinstalled seal connecting corners",
                "handle_installed": "Handle is installed or taped over",
                "handle_installed_tapped": "Handle is installed or taped over",
                "installed_plumb": "Window installed plumb square and level",
                "integral_mullion": "Integral mullion connections are properly sealed from all sides",
                "integral_mullion_connection": "Integral mullion connections are properly sealed from all sides, and corner metal L brackets are fully embedded in sealant",
                "jambs_wedged": "Jambs of the wooden buck are wedged",
                "locked_position": "Windows are in closed & locked position",
                "locking_points": "Locking points are adjusted to the maximum pressure",
                "locking_points_adjusted": "Locking points are adjusted to maximum pressure",
                "locking_points_pressure": "Locking points are adjusted to maximum pressure (winter mode)",
                "no_defects": "There are no defects on the welded corners rubber and it is soft to press",
                "no_equalization_holes_jambs": "Ensure that there are no equalization holes in the jambs of the frame, only in the glazing stops If equalization holes are present in these frame locations, please apply sealant",
                "no_gap_mullion_cap_frame": "No gaps between the exterior connecting mullion cap and frame",
                "no_gaps_miter_joint": "Ensure that there are no gaps at miter joint of exterior glazing beads If gaps are present, please apply sealant to the gap",
                "open_sash_operation": "Open sash to ensure proper operation and locking",
                "plumb_level_square": "Windows is installed plumb, level, and square",
                "protective_stickers": "All protective stickers are off",
                "sash_gaskets_proper": "Sash gaskets are properly adhered to all sides of the frame",
                "sash_is_square": "Sash is square and level",
                "sash_limiter_arm_engaged": "Operable sash limiter arm is properly engaged into the receiver on the frame",
                "sash_square_level": "Sash is adjusted, square, level, and has an equal overlap on all sides",
                "screws_wet_zone": "All screws in “wet zone” are sealed",
                "threshold_level_frame": "The threshold is level and even with the frame",
                "unglaze_unit": "Unglaze unit / open sash",
                "weather_proofing_skirt": "Weather proofing skirt is installed during testing",
                "weep_hole_covers": "Weep hole covers are installed",
                "weep_holes_connected": "Exterior and interior weep holes are connected",
                "weep_holes_high": "Weep holes are not cut too high from exterior and are free from debris",
                "weep_holes_place": "Weep holes are in the right places and in the right quantity from exterior",
                "weepholes_connected": "Weepholes are properly connected from interior to the exterior",
                "weepholes_cover_installed": "Weephole covers are installed",
                "weepholes_location_appropriate": "Weepholes are in the appropriate location and are free of debris (draining properly)",
                "welded_corner_gaskets": "Welded corner gaskets are free of defects and are soft to the touch (not stiff/brittle)",
                "wet_zone_screws": "All screws in wet zone are sealed"
            },
            "factory_test_field_testing": {
                "air": "Air",
                "assembling": "Assembling",
                "blower_door": "Blower Door",
                "other": "Other",
                "practical_application": "Practical Application",
                "water": "Water"
            },
            "general_installation_methods": {
                "approved_shop_drawings": "Review the most recent set of approved shop drawings, window schedule, and floor plans.",
                "check_squareness": "Check Squareness of rough openings.",
                "corner_on_jambs": "Shim products 6” from each corner on jambs and sill (do not shim headers). Install additional shims behind mullions and every 20” apart as needed. Refer to shimming pages in shop drawings (windows, hinged doors, sliding doors).",
                "ensure_rough_opening": "Ensure rough opening construction at sill is planned to prevent water from draining to the interior of building.",
                "explain_installation_methods": "If using metal L angle, explain installation methods, sealant points, fastener spacing for product and rough opening, and recommended fasteners.",
                "index": "General Installation Methods",
                "insert_mounting_bracket": "If using mounting brackets, insert mounting brackets on window frame and space as instructed. Secure brackets to window using the screws provided. Screws must reach steel reinforcement located within the window frame. Make sure to fully encapsulate mounting brackets in sealant.",
                "install_pbo_fastener": "If using flanged product (polymer flange / factory or field applied aluminum flange), install a P.B.O fastener as instructed to the rough opening. Also review proper sealant points to flange prior to setting window to the rough opening.",
                "place_window_unit": "Place products in rough opening. Be sure products are centered, level, plumb, and square. Adjust shims as necessary.",
                "remove_all_protection": "Advise site to remove all protection film from products.",
                "review_any_accessory": "Review any accessory or finishing products and installation methods (undersill profiles, widening profiles, brick extension, shadow boxes, screens, handles, hinge covers, etc.).",
                "review_of_rough_openings": "Review rough openings prior to installing products. If deficiencies are observed, advise GC or construction manager immediately.",
                "review_pre_drilling_methods": "If using screws through the frame, review pre-drilling methods, sealant points, screw spacing/placement, and recommended fasteners.",
                "sash_operation": "Check sash operation for all operable products before proceeding. Make appropriate adjustments as needed.",
                "tools_and_supplies": "Review installation kit, tools, and supplies needed to complete installation.",
                "weatherproofing": "Review proper waterproofing methods. Follow sealant manufacturers recommendations for compatibility and performance.",
                "weep_holes": "Discuss the importance of weep holes and weep hole covers. Ensure that weep hole covers are installed and clear of any potential blockage.",
                "window_flashing": "Window flashing must be installed on a clean and dry surface."
            },
            "install_insulated_glass_units": {
                "additional_remove_methods": "Discuss additional methods to remove glued glass or glued glazing beads.",
                "glass_shim_colors": "Review glass shim colors and locations. Reference locations of glass shims for reinstalling later.",
                "igu_in_safe_location": "Place IGU in safe location away from active construction to avoid damage in an upright position (DO NOT LAY GLASS FLAT)",
                "index": "Removing & Replacing Insulated Glass Units",
                "mark_reference_point": "Mark a reference point on removed glazing stops and product frame for reinstalling later.",
                "proper_tools_to_complete_task": "Review proper tools needed to complete task.",
                "reinstall_glazing_shims": "Reinstall glazing shims at marked locations and set IGU back into product frame.",
                "reinstall_glazing_stops": "Reinstall glazing stops back into original marked locations with rubber hammer to ensure properly seated (recommend which glazing stops to reinstall first for easier installation).",
                "sharp_edge_painters": "Carefully insert sharp edge painters’ tool between glazing stop and product frame groove (recommend which glazing stop to remove first for easy removal).",
                "suction_cup": "Ensure suction cup is firmly against glass surface and proceed to remove and maneuver IGU from frame."
            },
            "leed_project": {
                "index": "Leed Project",
                "no": "No",
                "unknown": "Unknown",
                "yes": "Yes"
            },
            "mulling_windows": {
                "apply_sealant": "Apply additional sealant along the top and bottom of the mullion.",
                "apply_silicone": "Apply sealant to the appropriate accessory groove or mullion prior to connecting the mullion to the product",
                "clamp_units": "Carefully clamp mullion to frame protecting products using a wood or plastic shim.",
                "clean_window": "Remove protection film from products and connection mullions. Clean windows to remove any dirt or dust and discuss the importance of mulling clean products.",
                "demonstrate_mullions_sit": "Demonstrate how mullions should properly sit onto product frames.",
                "glazing_unit": "Deglaze and remove IGUs from fixed product frames before product mullion installation.",
                "index": "Mulling Windows",
                "insulated_glass": "Properly reinstall IGUs / operable sashes back into position.",
                "operable_windows": "For all operable products, remove sash for easier handling. Do not deglaze unit unless needed.",
                "pre_drill_holes": "Measure and pre-drill mullion 8” from the corners and every 20” in between (or symmetrical). Do not exceed 20” between corner screws.",
                "repeat_for_second_mulled": "Repeat steps for second mulled unit.",
                "review_proper_screws": "Review proper screws to use when securing mullions to windows.",
                "snap_in_mullion": "Apply additional sealant along the two exterior groves then apply the mullion face snap cover."
            },
            "receptor_installation": {
                "backer_rod": "Apply backer rod and silicone gap between window frame and receptors in the header prior to securing stops to window and receptor.",
                "finish_sealing": "Once receptors are secured to rough opening, finish sealing the fixed end plates to assure they are watertight. Seal overtop of any screw holes that are exposed.",
                "fixed_end_plates": "Apply fixed end plates to each end of your receptor using silicone to seal it and 3.9 x 13 mm self-tapping screws to secure to receptor ends. (Head and sill receptors only, jamb receptors will slide between head and sill end plates once installed)",
                "index": "Receptor Installation",
                "leave_space_between": "Any sections where 2 receptors meet, leave a 9/16” space between both receptors then silicone 4-3/4” on center across both receptors and tape using a 4” piece of tape on center to properly join and seal both receptors. Be sure all areas are sealed and watertight.",
                "mounting_brackets": "Apply mounting brackets to bottom of receptors using a 4.2 x 19 mm self-taping screw.  Space brackets 6” from the corners and every 20” in between (or symmetrical). If mounting brackets are not being used, secure receptors with screws directly through the top of the receptor into rough opening.",
                "receptors_to_rough": "Set receptor to rough opening and shim properly to assure receptors are being installed level. RECEPTORS MUST BE LEVEL!",
                "rough_openings": "Measure rough openings to assure receptors will fit properly.",
                "silicone_sill": "Be sure to silicone the sill and header where the 2 windows meet prior to setting EZ mullions together. Trim gasket where EZ Mullions meet head and sill receptor (2”) and apply a continuous bead of sealant.",
                "snap_cap_covers": "Once EZ mullion covers are installed, apply snap cap covers around sides between windows and receptors as a finish piece to cover window stops.",
                "weep_hole": "Apply weep hole covers then backer rod and caulk between receptors and rough openings.",
                "window_continuous_bead": "Set windows in a continuous bead of sealant when ready to place windows into receptor(s)."
            },
            "report_acm_inspection": {
                "are_level": "Windows/doors are level, plumb and square.",
                "check_location": "Check location of stored windows, all stored windows are in a secure safe location out of the elements.",
                "correct_brackets": "Installed windows have correct amount of brackets installed or fasteners in flanges per shops.",
                "correct_spacing": "Installed window have correct spacing between window frame and rough opening per shops (may vary based on size of window).",
                "deglazing_needed": "If deglazing of IGU was needed, check to make sure all IGU glazing shims we properly reinstalled in frame.",
                "fastened_mullions": "Mullions are fastened and installed properly (remove glazing stop to confirm spacing of fasteners).",
                "index": "Inspection",
                "operating_properly": "Installed windows/doors are operating properly (where applicable).",
                "proper_shims": "Installed windows have proper shims at sill and jambs per shops.",
                "weep_hole": "Weep hole covers are in place."
            },
            "report_acm_inspection_v2": {
                "accessories_installed_properly": "Accessories are being installed properly.",
                "correct_number_brackets": "Installed products have correct number of brackets and brackets are fastened with the proper screw. Brackets are secured to the rough opening with appropriately sized fastener.",
                "correct_number_fasteners_L_angle": "Installed products have correct number of fasteners through metal L angle and are being attached to the rough opening with appropriately sized fastener.",
                "correct_number_fasteners_doors": "Installed products have correct number of fasteners through doors and are being attached to the rough opening with appropriately sized fastener. Ensure proper pre-drilling and sealant application is being applied to screws through the frame.",
                "correct_number_fasteners_flanges": "Installed products have correct number of fasteners through flanges and are being attached to the rough opening with appropriately sized fastener. Ensure proper sealant application behind flange (head/jambs, not sill).",
                "correct_spacing_window_frame": "Installed windows have the correct spacing in between the window frame and the rough opening per shops (may vary based on size of window).",
                "deglazing_IGUs": "If deglazing IGUs was required, check to make sure that all IGU glazing shims and glazing beads were properly reinstalled into the frame.",
                "flanged_products_taped": "Flanged products are properly taped in weatherboard fashion with aprons applied.",
                "index": "Inspection",
                "location_stored_windows": "Check location of stored windows. All stored windows are in a secure and safe location out of the elements.",
                "mullions_fastened_properly": "Mullions are fastened and installed properly. Ensure all sealant points are applied.",
                "proper_number_shims": "Installed products have proper number of shims at sill and jambs per shops.",
                "protection_stickers_removed": "Protection stickers are being removed from all products.",
                "rough_openings_waterproofed": "Rough openings are being waterproofed correctly.",
                "sealants_properly_applied": "Primary and secondary sealants are in place and properly applied.",
                "weep_hole_covers": "Weep hole covers are in place. Weep holes are not sealed over.",
                "windows_doors_level": "Windows/doors are level, plumb, and square.",
                "windows_doors_operating_properly": "Installed windows/doors are operating properly (where applicable)."
            },
            "report_damages": {
                "broken_frame": "Broken Frame",
                "broken_glass": "Broken Glass",
                "hardware": "Hardware",
                "igu": "IGU",
                "index": "Damages",
                "manufacturing_defect": "Manufacturing Defect",
                "missing_item": "Missing Item",
                "na": "N/A",
                "other": "Other",
                "transportation_damage": "Transportation Damage",
                "window_frame": "Window Frame"
            },
            "report_damages_cause": {
                "client_installer": "Client/Installer",
                "index": "Root Cause of Damages",
                "intus": "INTUS"
            },
            "report_delivery_inspection": {
                "adequate_manpower": "Adequate manpower is being used for unloading",
                "bol_match": "BOL Match pallet, boxes, steel reinforcements, mullions connections, etc.",
                "forklift": "Forklift or lull with fork extensions and load capacity that is greater than pallet weights (weights & size of pallets vary per project)",
                "index": "Delivery Inspection",
                "pallet_jack": "Pallet jack for moving pallets inside container",
                "pallets": "Pallets are being stored in a safe area and out of elements",
                "straps": "Straps are being used to unload pallets. Straps should have a load capacity of at least 5000lbs",
                "unloader": "Unloader is safely unloading pallets & handling correctly"
            },
            "report_field_inspection": {
                "aluminum_flange_perimeter": "Aluminum flange has perimeter sealant at the flange-to-frame location",
                "connecting_mullions_sealed": "Connecting mullions are properly sealed at the top and bottom",
                "door_frame_and_sash_free_of_debris": "Door frame and sash gaskets, glazing bead gaskets, and thresholds are cleaned and free of debris.",
                "door_sash_adjusted": "The door sash is properly adjusted so that the gasket is overlapped on all 4 sides",
                "equal_overlap": "Sash has equal overlap from all sides",
                "equalization_exterior": "Equalization holes are in the right places and in the right quantity from exterior",
                "equalization_interior": "Equalization and weep holes are in the right places and in the right quantities from interior",
                "gasket_soft_clean": "Gasket is soft and clean",
                "glazing_beads_reinstalled": "If glazing beads were removed and reinstalled, or have gaps in the corners, seal connecting corners of glazing beads",
                "glazing_shims": "Glazing shims are not blocking weep holes or equalization holes",
                "glazing_stops": "If glazing stops were reinstalled seal connecting corners",
                "handle_installed": "Handle is installed or taped over",
                "handle_installed_tapped": "Handle is installed or taped over",
                "index": "Pre Testing Inspection",
                "installed_plumb": "Window installed plumb square and level",
                "integral_mullion": "Integral mullion connections are properly sealed from all sides",
                "integral_mullion_connection": "Integral mullion connections are properly sealed from all sides, and corner metal L brackets are fully embedded in sealant",
                "jambs_wedged": "Jambs of the wooden buck are wedged",
                "locked_position": "Windows are in closed & locked position",
                "locking_points": "Locking points are adjusted to the maximum pressure",
                "locking_points_adjusted": "Locking points are adjusted to maximum pressure",
                "locking_points_pressure": "Locking points are adjusted to maximum pressure (winter mode)",
                "no_defects": "There are no defects on the welded corners rubber and it is soft to press",
                "no_equalization_holes_jambs": "Ensure that there are no equalization holes in the jambs of the frame, only in the glazing stops If equalization holes are present in these frame locations, please apply sealant",
                "no_gap_mullion_cap_frame": "No gaps between the exterior connecting mullion cap and frame",
                "no_gaps_miter_joint": "Ensure that there are no gaps at miter joint of exterior glazing beads If gaps are present, please apply sealant to the gap",
                "open_sash_operation": "Open sash to ensure proper operation and locking",
                "plumb_level_square": "Windows is installed plumb, level, and square",
                "protective_stickers": "All protective stickers are off",
                "sash_gaskets_proper": "Sash gaskets are properly adhered to all sides of the frame",
                "sash_is_square": "Sash is square and level",
                "sash_limiter_arm_engaged": "Operable sash limiter arm is properly engaged into the receiver on the frame",
                "sash_square_level": "Sash is adjusted, square, level, and has an equal overlap on all sides",
                "screws_wet_zone": "All screws in “wet zone” are sealed",
                "threshold_level_frame": "The threshold is level and even with the frame",
                "unglaze_unit": "Unglaze unit / open sash",
                "weather_proofing_skirt": "Weather proofing skirt is installed during testing",
                "weep_hole_covers": "Weep hole covers are installed",
                "weep_holes_connected": "Exterior and interior weep holes are connected",
                "weep_holes_high": "Weep holes are not cut too high from exterior and are free from debris",
                "weep_holes_place": "Weep holes are in the right places and in the right quantity from exterior",
                "weepholes_connected": "Weepholes are properly connected from interior to the exterior",
                "weepholes_cover_installed": "Weephole covers are installed",
                "weepholes_location_appropriate": "Weepholes are in the appropriate location and are free of debris (draining properly)",
                "welded_corner_gaskets": "Welded corner gaskets are free of defects and are soft to the touch (not stiff/brittle)",
                "wet_zone_screws": "All screws in wet zone are sealed",
                "windows_glazing_free_of_debris": "Window glazing bead gaskets and operable sash gaskets are cleaned and free of debris."
            },
            "report_field_testing": {
                "air": "Air",
                "assembling": "Assembling",
                "blower_door": "Blower Door",
                "index": "Testing",
                "other": "Other",
                "practical_application": "Practical Application",
                "water": "Water"
            },
            "report_install_care_maintenance": {
                "advice": "Advice of operational steps as well as maintenance obligations required regarding the installed product",
                "explain_adjustments": "Explain window & door adjustments",
                "index": "Care & Maintenance",
                "review_qr": "Review QR codes usage and enter services correctly",
                "walk_thru": "Walk-thru with installer & GC for operation review"
            },
            "report_install_delivery": {
                "index": "Delivery",
                "job_site_condition": "Job site condition, items store in secure location",
                "proper_equipment": "Proper equipment and tools for unloading",
                "signs_of_damage": "Check signs of damage & report any damage items as soon as possible"
            },
            "report_install_handling_and_storage": {
                "accessible_route": "Accessible route to rough openings or storage locations",
                "doors_and_windows": "Doors and windows should be handled with clean hands and equipment",
                "glass_stored": "Glass must never be stored or transported in a horizontal orientation",
                "index": "Handling and Storage",
                "protect_windows": "Protect the interior and exterior of windows or doors from contact with harsh chemical washes, construction material contamination and moisture",
                "storage_area": "If the product must be stored before installation, store on a level surface in a dry, well ventilated area, and out of the elements"
            },
            "report_install_installation": {
                "approved_shop_drawings": "Review the most recent set of approved shop drawings, window schedule, floor plans",
                "check_squareness": "Check squareness of rough opening",
                "corner_on_jambs": "Shim 6” from each corner on jambs and sill (follow Intus instructions). Do not shim top of the window. Install additional shims every 20” if needed.",
                "ensure_rough_opening": "Ensure rough opening construction at sill is planned to prevent water draining to the interior",
                "index": "Installation",
                "insert_mounting_bracket": "Insert mounting bracket on marked spacing as per instructions",
                "place_window_unit": "Place window unit in opening. Center, level at sill and plumb frame (interior & exterior). Adjust shims as necessary.",
                "review_of_rough_openings": "Review of rough openings prior to installing windows. If deficiencies are observed, advise the GC or construction Manager immediately.",
                "sash_operation": "Check sash operation for all operable windows before proceeding",
                "secure_all_mounting": "Secure all mounting brackets to window frame by using provided #8. Screw must reach steel reinforcement located within window frame.",
                "tools_and_supplies": "Check tools and supplies required for installation",
                "weatherproofing": "Weatherproofing. Follow sealant manufacturer’s recommendations for compatibility and performance.",
                "weep_holes": "Ensure weep holes are not covered with sealant",
                "window_flashing": "Window flashing must be installed on clean, dry surfaces and free of frost"
            },
            "report_install_insulated_glass": {
                "glazing_beads": "Clip all glazing beads to its belonging position. Use a rubber hummer if needed.",
                "glazing_shim": "Replace all glazing shims at marked reference points. Carefully place insulated glass unit in place.",
                "index": "Removing & Replacing Insulated Glass Unit",
                "insulated_glass": "Place insulated glass unit in a safe place to avoid breakage",
                "reference_point": "Mark a reference point on removed glazing beads and window frame for later repositioning",
                "reference_points": "Mark up reference points where glazing shims are located and remove them",
                "sharp_edge": "Carefully insert sharp edge of painters tool between glazing bead and window frame groove",
                "suction_cups": "Press suction cups firmly against glass surface and proceed to remove insulated glass unit"
            },
            "report_install_mulling_windows": {
                "apply_sealant": "Apply sealant on top and bottom of mullion",
                "apply_silicone": "Apply silicone to the groves on both window frames being mulled",
                "clamp_units": "Carefully clamp units together protecting window frame with wooden or plastic shims",
                "clean_window": "Clean window from any dust",
                "glazing_unit": "Glazing unit shall be removed from the fixed window frame before window mullion installation",
                "index": "Mulling Windows (if applicable)",
                "insulated_glass": "Finalize by placing insulated glass unit back to its original position. Confirm glazing shims on replaced and installed in proper locations.",
                "operable_windows": "For all operable windows remove sash for easier handling. Do not unglaze unit unless replacing a broken glass.",
                "pre_drill_holes": "Pre-drill holes 8” from corners, and 20” o.c. Anchor units together using 3 1/2” long steel screws",
                "protected_film": "Remove protected film from both window frames sides where mullion will be installed",
                "snap_in_mullion": "Snap in mullion into both frame grooves",
                "window_frames": "Place two window frames together"
            },
            "report_service": {
                "document_steps": "Document steps taken to resolve service opportunity or if next steps are needed to resolve service. Explain process and findings.",
                "document_the_unit": "Document the unit, floor, & window position that you inspected",
                "index": "Service",
                "measurements": "Include measurements of the window",
                "service_opportunity": "Provide detail description of service opportunity",
                "specific_area": "Inspect specific area of concern based on service call",
                "verify_the_cause": "Verify the cause of the concern or issue"
            }
        },
        "qr_reader": {
            "default_scan_error": "Scan failed. Please check if QR-code belongs to INTUS",
            "default_title": "Scan QR Code",
            "error": "Error",
            "errors": {
                "camera_not_readable": "Is the camera already in use?",
                "camera_not_suitable": "Installed cameras are not suitable.",
                "camera_permission": "You need to grant camera access permission.",
                "cross_origin": "Sorry, you can't load cross-origin images.",
                "no_camera": "No cameras found on this device.",
                "not_image": "File is not an image. That can't be decoded.",
                "secure_context": "Secure context required (HTTPS, localhost).",
                "stream_api": "Stream API is not supported in this browser.",
                "unknown": "Unknown error occurred! {message}"
            },
            "retry": "Retry",
            "scanned": "Scanned"
        }
    }
}
